module.exports = __webpack_public_path__ + "media/images/img_service_step_2-017c345ff5922af99e94564a88187650.png";